"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value.length === 0;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isEmpty.js
// module id = 998
// module chunks = 0